import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bc8ff5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header card-header-stretch pb-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "m-0" }, "Список каналів")
], -1))
const _hoisted_4 = { class: "card-toolbar m-0" }
const _hoisted_5 = {
  class: "nav nav-stretch nav-line-tabs border-transparent",
  role: "tablist"
}
const _hoisted_6 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  id: "kt_analog_channels_tab",
  class: "nav-link fs-5 fw-bolder me-5 active",
  "data-bs-toggle": "tab",
  role: "tab",
  href: "#kt_analog_channels_list_tab",
  "aria-selected": "true"
}, " Аналогові ", -1))
const _hoisted_8 = {
  class: "badge badge-success mt-2 p-2",
  style: {"height":"22px"}
}
const _hoisted_9 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  id: "kt_digital_channels_tab",
  class: "nav-link fs-5 fw-bolder",
  "data-bs-toggle": "tab",
  role: "tab",
  href: "#kt_digital_channels_list_tab",
  "aria-selected": "false"
}, " Цифрові ", -1))
const _hoisted_11 = {
  class: "badge badge-success mt-2 p-2",
  style: {"height":"22px"}
}
const _hoisted_12 = { class: "d-flex align-items-center py-3 py-md-1" }
const _hoisted_13 = { class: "me-1 ms-7" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-light",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M19.0759 3H4.72777C3.95892 3 3.47768 3.83148 3.86067 4.49814L8.56967 12.6949C9.17923 13.7559 9.5 14.9582 9.5 16.1819V19.5072C9.5 20.2189 10.2223 20.7028 10.8805 20.432L13.8805 19.1977C14.2553 19.0435 14.5 18.6783 14.5 18.273V13.8372C14.5 12.8089 14.8171 11.8056 15.408 10.964L19.8943 4.57465C20.3596 3.912 19.8856 3 19.0759 3Z",
        fill: "black"
      })
    ])
  ]),
  /*#__PURE__*/_createTextVNode(" Фільтр ")
], -1))
const _hoisted_15 = {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-300px",
  "data-kt-menu": "true",
  id: "kt_menu_61de0f42594ca",
  style: {}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-7 py-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 text-dark fw-bolder" }, "Опції фільтра")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1))
const _hoisted_18 = { class: "px-7 py-5" }
const _hoisted_19 = { class: "mb-10" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Назва каналу:", -1))
const _hoisted_21 = { class: "d-flex" }
const _hoisted_22 = { class: "mb-10" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Категорія:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1))
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "mb-10" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "HD Якість:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  id: "kt_channels_tab_content",
  class: "card-body tab-content"
}
const _hoisted_31 = {
  id: "kt_analog_channels_list_tab",
  class: "tab-pane fade active show",
  role: "tabpanel"
}
const _hoisted_32 = {
  key: 0,
  class: "row g-0 justify-content-center"
}
const _hoisted_33 = {
  key: 0,
  class: "card-header card-header-stretch pb-0"
}
const _hoisted_34 = { class: "card-title mt-0" }
const _hoisted_35 = { class: "m-0" }
const _hoisted_36 = { class: "badge badge-success" }
const _hoisted_37 = {
  key: 1,
  class: "card-body tab-content"
}
const _hoisted_38 = ["id"]
const _hoisted_39 = { class: "row gx-9 gy-6" }
const _hoisted_40 = { class: "card card-dashed h-xl-100 flex-row flex-stack flex-wrap p-6" }
const _hoisted_41 = { class: "d-flex flex-column py-2" }
const _hoisted_42 = { class: "d-flex align-items-center fs-4 fw-bolder mb-5" }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = { class: "badge badge-light-success fs-7 ms-2" }
const _hoisted_45 = { class: "d-flex align-items-center" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "fs-4 fw-bolder" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-400" }, "частота", -1))
const _hoisted_49 = { class: "d-flex align-items-right py-2" }
const _hoisted_50 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_51 = {
  id: "kt_digital_channels_list_tab",
  class: "tab-pane fade",
  role: "tabpanel",
  "aria-labelledby": "kt_billing_paypal_tab"
}
const _hoisted_52 = {
  key: 0,
  class: "row g-0 justify-content-center"
}
const _hoisted_53 = {
  key: 0,
  class: "card-header card-header-stretch pb-0"
}
const _hoisted_54 = { class: "card-title mt-0" }
const _hoisted_55 = { class: "m-0" }
const _hoisted_56 = { class: "badge badge-success" }
const _hoisted_57 = {
  key: 1,
  class: "card-body tab-content"
}
const _hoisted_58 = ["id"]
const _hoisted_59 = { class: "row gx-9 gy-6" }
const _hoisted_60 = { class: "card card-dashed h-xl-100 flex-row flex-stack flex-wrap p-6" }
const _hoisted_61 = { class: "d-flex flex-column py-2" }
const _hoisted_62 = { class: "d-flex align-items-center fs-4 fw-bolder mb-5" }
const _hoisted_63 = ["innerHTML"]
const _hoisted_64 = { class: "badge badge-light-success fs-7 ms-2" }
const _hoisted_65 = { class: "d-flex align-items-center" }
const _hoisted_66 = ["src"]
const _hoisted_67 = { class: "fs-4 fw-bolder" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-400" }, "частота", -1))
const _hoisted_69 = { class: "d-flex align-items-right py-2" }
const _hoisted_70 = {
  key: 0,
  class: "badge badge-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.channels_list_analog_count), 1)
          ]),
          _createElementVNode("li", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.channels_list_digital_count), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-lg form-control-solid",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter_channel_name) = $event)),
                      placeholder: "Пошук за назвою каналу",
                      autocomplete: "off"
                    }, null, 512), [
                      [_vModelText, _ctx.filter_channel_name]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-solid select2-hidden-accessible",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter_channel_category) = $event)),
                      "data-kt-select2": "true",
                      "data-placeholder": "Оберіть категорію",
                      "data-allow-clear": "true",
                      tabindex: "-1",
                      "aria-hidden": "true"
                    }, [
                      _hoisted_24,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userData.channels_list_analog, (channel_category_filter, index_filter) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: channel_category_filter.category_id,
                          key: index_filter
                        }, _toDisplayString(channel_category_filter.category_label), 9, _hoisted_25))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.filter_channel_category]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-solid select2-hidden-accessible",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter_channel_hd_type) = $event)),
                      "data-kt-select2": "true",
                      "data-placeholder": "Оберіть якість",
                      "data-allow-clear": "true",
                      tabindex: "-1",
                      "aria-hidden": "true"
                    }, [
                      _hoisted_28,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userData.channels_hd_types, (channel_hd_type_filter, index_filter) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: channel_hd_type_filter.id,
                          key: index_filter
                        }, _toDisplayString(channel_hd_type_filter.header), 9, _hoisted_29))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.filter_channel_hd_type]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        (_ctx.channels_list_analog != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channels_list_analog, (channel_category, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "card mb-5 mb-xl-10",
                  key: channel_category.category_id
                }, [
                  (channel_category.channels.length  > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("h3", _hoisted_35, [
                            _createElementVNode("label", _hoisted_36, _toDisplayString(channel_category.channels.length), 1),
                            _createTextVNode(" " + _toDisplayString(channel_category.category_label), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (channel_category.channels.length  > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("div", {
                          id: 'channel-tab' + index,
                          role: "tabpanel"
                        }, [
                          _createElementVNode("div", _hoisted_39, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channel_category.channels, (channel) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "col-12 col-xl-4 col-lg-6 col-md-6 col-sm-12",
                                key: channel.id
                              }, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("div", _hoisted_42, [
                                      _createElementVNode("div", {
                                        innerHTML: channel.channel_name
                                      }, null, 8, _hoisted_43),
                                      _createElementVNode("span", _hoisted_44, "№ " + _toDisplayString(channel.channel_number), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_45, [
                                      _createElementVNode("img", {
                                        src: channel.image_url,
                                        alt: "",
                                        class: "img-thumbnail me-4 w-25"
                                      }, null, 8, _hoisted_46),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_47, _toDisplayString(channel.freq_analog), 1),
                                        _hoisted_48
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_49, [
                                    (channel.hd_type_label != '')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(channel.hd_type_label), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ], 8, _hoisted_38)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_51, [
        (_ctx.channels_list_digital)
          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channels_list_digital, (channel_category, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "card mb-5 mb-xl-10",
                  key: channel_category.category_id
                }, [
                  (channel_category.channels.length  > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("h3", _hoisted_55, [
                            _createElementVNode("label", _hoisted_56, _toDisplayString(channel_category.channels.length), 1),
                            _createTextVNode(" " + _toDisplayString(channel_category.category_label), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (channel_category.channels.length  > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("div", {
                          id: 'channel-tab' + index,
                          role: "tabpanel"
                        }, [
                          _createElementVNode("div", _hoisted_59, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channel_category.channels, (channel) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "col-12 col-xl-4 col-lg-6 col-md-6 col-sm-12",
                                key: channel.id
                              }, [
                                _createElementVNode("div", _hoisted_60, [
                                  _createElementVNode("div", _hoisted_61, [
                                    _createElementVNode("div", _hoisted_62, [
                                      _createElementVNode("div", {
                                        innerHTML: channel.channel_name
                                      }, null, 8, _hoisted_63),
                                      _createElementVNode("span", _hoisted_64, "№ " + _toDisplayString(channel.channel_number), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_65, [
                                      _createElementVNode("img", {
                                        src: channel.image_url,
                                        alt: "",
                                        class: "img-thumbnail me-4 w-25"
                                      }, null, 8, _hoisted_66),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_67, _toDisplayString(channel.freq_digital), 1),
                                        _hoisted_68
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_69, [
                                    (channel.hd_type_label != '')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(channel.hd_type_label), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ], 8, _hoisted_58)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}